import Vue from 'vue';

Vue.use(VueConstructor => {
  // eslint-disable-next-line no-param-reassign
  VueConstructor.prototype.$pt = function prefixedTranslation(prefix, translationKey) {
    const combinedKey = `${prefix}.${translationKey}`;
    const translation = this.$t(combinedKey);

    return translation !== combinedKey ? translation : translationKey;
  };
});
